import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Button } from '@material-ui/core';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import LoopIcon from '@material-ui/icons/Loop';
import { PDFDownloadLink } from '@react-pdf/renderer';

import './index.scss';

import SeatPlan from "./seatPlan";
import AttendanceSheet from "./attendanceSheet";
import MasterSheet from "./masterSheet";

class Report extends Component {
  constructor(props) {
    super(props)

    this.generateSeatPlan = this.generateSeatPlan.bind(this)
  }
  
  /**
   * Returns an array with arrays of the given size.
   *
   * @param myArray {Array} Array to split
   * @param chunkSize {Integer} Size of every group
   */
  chunkArray(myArray, chunk_size){
    let result = []
    let arrayCopy = [...myArray]
    while (arrayCopy.length > 0) {
        result.push(arrayCopy.splice(0, chunk_size))
    }
    return result
  }

  generateSeatPlan = (fromData, seatPlans) => {
    return (
      <PDFDownloadLink className="link" document={<SeatPlan fromData={fromData}  sheetPlanData={ seatPlans }/>} fileName="seat-plan.pdf">
        {
          ({ blob, url, loading, error }) => {
            return (
              <Button variant="contained" color="primary" className="btn-download">
                {
                  loading ? (
                    <React.Fragment>
                      <LoopIcon />
                      <span>
                        Loading document...
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <CloudDownloadIcon />
                      <span>
                        Download Sheet Plan
                      </span>
                    </React.Fragment>
                  )
                }
              </Button>
            )
          }
        }
      </PDFDownloadLink>
    )
  }

  generateAttendanceSheet = (fromData, seatPlans) => {
    const plan = seatPlans.map(s => {
      const attendanceData = this.chunkArray(s.attendence, 30)

      return {
        ...s,
        attendence: attendanceData
      }
    })
    return (
      <PDFDownloadLink className="link" document={<AttendanceSheet fromData={fromData} attendanceData={plan}/>} fileName="attendance-sheet.pdf">
        {
          ({ blob, url, loading, error }) => {
            return (
              <Button variant="contained" color="primary" className="btn-download">
                {
                  loading ? (
                    <React.Fragment>
                      <LoopIcon />
                      <span>
                        Loading document...
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <CloudDownloadIcon />
                      <span>
                        Download Attendence Sheet
                      </span>
                    </React.Fragment>
                  )
                }
              </Button>
            )
          }
        }
      </PDFDownloadLink>
    )
  }

  generateMasterSheet = (fromData, seatPlans) => {
    const rooms = seatPlans.map((r, i) => {
      const att = r.attendence
      return {
        id: i + 1,
        roomNumber: r.roomName,
        rollNumbers: att[0].examRollNumber + ' - ' + att[att.length - 1].examRollNumber
      }
    })
    return (
      <PDFDownloadLink className="link" document={<MasterSheet fromData={fromData} rooms={rooms}/>} fileName="master-sheet.pdf">
        {
          ({ blob, url, loading, error }) => {
            return (
              <Button variant="contained" color="primary" className="btn-download">
                {
                  loading ? (
                    <React.Fragment>
                      <LoopIcon />
                      <span>
                        Loading document...
                      </span>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <CloudDownloadIcon />
                      <span>
                        Download Master Sheet
                      </span>
                    </React.Fragment>
                  )
                }
              </Button>
            )
          }
        }
      </PDFDownloadLink>
    )
  }

  render() {
    const { seatPlans, fromData } = this.props
    return (
      <div>
        <hr/>
        { this.generateSeatPlan(fromData, seatPlans) }
        { this.generateAttendanceSheet(fromData, seatPlans)}
        { this.generateMasterSheet(fromData, seatPlans) }
      </div>
    )
  }
}

Report.propTypes = {
  seatPlans: PropTypes.array,
  fromData: PropTypes.object
}

export default Report
